export interface ISubFrotaModel {
    guid?: string,
    codigo?: number,
    codigoIdentificacao?: string,
    descricao?: string,
    cidade?: string,
    uf?: string,
    flagCentroCusto?: string,
    flagPadrao?: string,
    qtdeVeiculos?: number,
    codigoFrota?: number | null,
    nomeReduzidoFrota?: string,
    subFrotaCentroCusto?: number,
    nomeSubFrotaCentroCusto? : string,
    codigoContato? :number,
    nomeContato? : string;
    telefoneContato? : string,
    cnpj?: string,
    inscr?: string,
    iest?: string,
    emailNfe?: string,
    indPermiteConfiguracaoContingencia?: number,
    codigoContingencia?: string,
    valorLimiteContingencia?: number,
    codigoTipoContingencia?: string,
    codigoIntervaloContingencia?: string,
    codigoValidacaoCombustivel?: string,
    enderecos :IEnderecoSubFrotaModel[],
    flagBloqueioPostoNovo?: string,
    flagMostrarBloqueioPostoNovo?: string
    idRodocred?: string
}

export interface IRetornoSubFrotaModel {
    retorno: ISubFrotaModel,
    sucesso: boolean,
    mensagens: string[]
}

export interface IConsultaSubFrotaModel {
    retorno: ISubFrotaModel[],
    sucesso: boolean,
    mensagens: string[]
}

export interface IFiltroSubFrotaModel {
    guid: string,
    codigoFrota?: number | null,
    codigoSubFrota?: number,
    uf?: string,
    flagCentroCusto?: string,
    coluna?: string,
    operador?: number,
    parametro?: string
}

export interface IEnderecoSubFrotaModel {
    tipo: string,
    endereco?: string,
    numero?: string,
    complemento?: string,
    bairro?: string,
    cidade?: string,
    estado?: string,
    cep?: string
}

export interface IVeiculoSubFrotaModel {
    placa: string,
    apelido: string,
    anoFabricacao?: number,
    marca: string,
    modelo: string,
    combustivel: string,
    status: string
}

export interface IConsultaVeiculoSubFrotaModel {
    retorno: IVeiculoSubFrotaModel[],
    sucesso: boolean,
    mensagens: string[]
}





